import { render, staticRenderFns } from "./mailbox-table.vue?vue&type=template&id=7a112e65&scoped=true&"
import script from "./mailbox-table.ts?vue&type=script&lang=ts&"
export * from "./mailbox-table.ts?vue&type=script&lang=ts&"
import style0 from "./mailbox-table.scss?vue&type=style&index=0&id=7a112e65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a112e65",
  null
  
)

export default component.exports